export const isSandbox = process.env.REACT_APP_ENV_TYPE === 'STAGING';
export const isDev = process.env.REACT_APP_ENV_TYPE === 'DEV';
